export const TAB_STATUS_UPDATE = 'Status';
export const TAB_PROGRESS_NOTE_UPDATE = 'Progress Note';
export const TAB_PATIENT_INFO_UPDATE = 'Patient Info';
export const TAB_STIPEND_UPDATE = 'Stipend Update';
export const STATUSES_WITHOUT_REASON = ['IDENTIFIED', 'PRE-SCREENED', 'PRE-SCREENING'];
export const STATUSES_WITHOUT_COMMENT = ['IDENTIFIED', 'PRE-SCREENED', 'PRE-SCREENING', 'PRE-SCREEN FAILED'];
export const ALLOWED_FORMATS = [
  '.xls',
  'application/vnd.ms-excel',
  '.xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.csv',
  'text/csv'
];

export const PATIENT_ID_KEY = 'Patient ID';
export const MRN_KEY = 'MRN';
export const SUBJECT_ID_KEY = 'Subject ID';
export const SOURCE_TYPE_KEY = 'Patient Origination Source Category';
export const SOURCE_NAME_KEY = 'Patient Origination Source';
export const SURVEY_NUMBER_KEY = 'Survey Number';

export const EXPECTED_KEYS_FOR_PATIENT_INFO_UPDATE = [
  PATIENT_ID_KEY,
  MRN_KEY,
  SUBJECT_ID_KEY,
  SOURCE_TYPE_KEY,
  SOURCE_NAME_KEY
];
export const REQUIRED_KEYS_FOR_PATIENT_INFO_UPDATE = [PATIENT_ID_KEY];
export const REQUIRED_KEYS_FOR_STIPEND_UPDATE = [MRN_KEY, SURVEY_NUMBER_KEY];
export const EXPECTED_KEYS_FOR_STIPEND_UPDATE = [MRN_KEY, SURVEY_NUMBER_KEY];

export const DESIRED_MAPPING = Object.freeze({
  PatientID: 'patientId'
});
